import React from "react";
import { useTranslation } from "react-i18next";

import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import projects from "./projectsData";

function ProjectSingleDIGICREATE() {
  const { t } = useTranslation("projectsTranslation");

  const project = projects.find((p) => p.i18nKey === "digicreate");
  const baseKey = "projects.digicreate";

  const objectives = t(`${baseKey}.page.objectives`, {
    returnObjects: true,
  });

  const activities = t(`${baseKey}.page.activities`, {
    returnObjects: true,
  });

  const workPackages = t(`${baseKey}.page.workPackages`, {
    returnObjects: true,
  });

  return (
    <>
      <Navbar />
      <Bredcom subtitle={t(`${baseKey}.page.title`)} />

      <div className="container mt-4 pt-40 project-detail digicreate-page">
        <div className="row">
          {/* MAIN CONTENT */}
          <div className="col-lg-8 col-md-7">
            <div className="content-container lower-content">
              {/* Cover */}
              {project?.coverImage && (
                <div className="project-cover mb-4">
                  <img
                    src={project.coverImage}
                    alt={t(`${baseKey}.page.title`)}
                    className="img-fluid"
                    style={{ borderRadius: 16, width: "100%" }}
                  />
                </div>
              )}

              {/* partners_cover */}
              {project?.coverImage && (
                <div className="project-cover mb-4">
                  <img
                    src={project.partnersImage}
                    alt={t(`${baseKey}.page.title`)}
                    className="img-fluid"
                    style={{ borderRadius: 16, width: "100%" }}
                  />
                </div>
              )}

              <h2 className="section-title">{t(`${baseKey}.page.title`)}</h2>

              {/* Intro */}
              <div className="textjustify">
                {t(`${baseKey}.page.intro`, { returnObjects: true }).map(
                  (p, idx) => (
                    <p key={idx}>{p}</p>
                  )
                )}
              </div>

              {/* Objectives */}
              <h3 className="mt-30">{t(`${baseKey}.page.objectivesTitle`)}</h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(objectives) ? objectives : []).map(
                    (item, idx) => (
                      <li key={idx}>{item}</li>
                    )
                  )}
                </ul>
              </div>

              {/* Activities */}
              <h3 className="mt-30">{t(`${baseKey}.page.activitiesTitle`)}</h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(activities) ? activities : []).map(
                    (item, idx) => (
                      <li key={idx}>{item}</li>
                    )
                  )}
                </ul>
              </div>

              {/* Work Packages */}
              <h3 className="mt-30">
                {t(`${baseKey}.page.workPackagesTitle`)}
              </h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(workPackages) ? workPackages : []).map(
                    (wp, idx) => (
                      <li key={idx}>
                        <strong>{wp.title}</strong> – {wp.description}
                      </li>
                    )
                  )}
                </ul>
              </div>

              {/* CONSORTIUM & PARTNERS */}
              <h3 className="mt-40">{t(`${baseKey}.page.consortiumTitle`)}</h3>

              <div className="textjustify">
                {t(`${baseKey}.page.consortiumIntro`, {
                  returnObjects: true,
                }).map((p, idx) => (
                  <p key={`cons-intro-${idx}`}>{p}</p>
                ))}

                {t(`${baseKey}.page.consortiumApproach`, {
                  returnObjects: true,
                }).map((p, idx) => (
                  <p key={`cons-approach-${idx}`}>{p}</p>
                ))}
              </div>

              <h4 className="mt-30">{t(`${baseKey}.page.partnersTitle`)}</h4>

              <div className="values-section">
                <ul>
                  {t(`${baseKey}.page.partners`, { returnObjects: true }).map(
                    (partner, idx) => (
                      <li
                        key={`partner-${idx}`}
                        style={{ marginBottom: "20px" }}
                      >
                        <strong>{partner.name}</strong> ({partner.country})
                        <br />
                        <em>{partner.role}</em>
                        <p style={{ marginTop: "6px" }}>
                          {partner.description}
                        </p>
                        <a
                          href={partner.website}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {partner.website}
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>

              {/* Disclaimer */}
              <div className="ofpep-section mt-30">
                <p className="textjustify">
                  <em>{t(`${baseKey}.page.disclaimer`)}</em>
                </p>
              </div>
            </div>
          </div>

          {/* SIDEBAR */}
          {/* SIDEBAR */}
          <div className="col-lg-4 col-md-5">
            <div className="info-column">
              <div className="inner-column3">
                <h3>{t(`${baseKey}.sidebar.title`)}</h3>

                <ul className="project-info">
                  <li>
                    <span className="icon">
                      <i className="fas fa-project-diagram" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.programmeLabel`)}</h5>
                      <p>{project?.programme}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-calendar-alt" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.durationLabel`)}</h5>
                      <p>{project?.duration}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-users" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.participantsLabel`)}</h5>
                      <p>2,500+</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-university" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.coordinatorLabel`)}</h5>
                      <p>{project?.coordinator}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-globe" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.websiteLabel`)}</h5>
                      <p>
                        <a
                          href={project?.website}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          digicreate-empower.eu
                        </a>
                      </p>
                    </div>
                  </li>

                  {/* SOCIAL LINKS */}
                  <li>
                    <span className="icon">
                      <i className="fab fa-facebook-f" />
                    </span>
                    <div>
                      <h5>Facebook</h5>
                      <p>
                        <a
                          href="https://www.facebook.com/digicreate.empower"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          digicreate.empower
                        </a>
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fab fa-linkedin-in" />
                    </span>
                    <div>
                      <h5>LinkedIn</h5>
                      <p>
                        <a
                          href="https://www.linkedin.com/company/digicreate-empower/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          DigiCreate Empower
                        </a>
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fab fa-twitter" />
                    </span>
                    <div>
                      <h5>X (Twitter)</h5>
                      <p>
                        <a
                          href="https://x.com/DigiCreate_"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          @DigiCreate_
                        </a>
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fab fa-instagram" />
                    </span>
                    <div>
                      <h5>Instagram</h5>
                      <p>
                        <a
                          href="https://www.instagram.com/digicreate.empower/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          @digicreate.empower
                        </a>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ProjectSingleDIGICREATE;
